import React, { useEffect, useState } from "react";
import styles from "./AdminVideo.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import dayjs from "dayjs";
import moment from "moment";
import toast from "react-hot-toast";
import videoIcon from "../../../../../../img/VideoPlayIcon.png";
import INS from "../../../../../../img/socialicons/insta.png";
import FB from "../../../../../../img/socialicons/facebook.png";

function ViewImageAdminInfo() {
  const navigate = useNavigate();
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  // let isAdmin = false;
  let user_type = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
      user_type = user.user_type;

      // isAdmin = user.is_admin === 1;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  const [isLoading, setIsLoading] = useState(false);
  const [folderData, setFolderData] = useState([]); // Renamed to folderData
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmations, setShowConfirmations] = useState(false);

  useEffect(
    () => {
      // if (id && folderData.length === 0) {
      handleFetchFolderData();
      // }
    },
    []
    // [id, folderData.length]
  );

  const handleFetchFolderData = async () => {
    setIsLoading(true);
    const folderPayload = {
      img_type: 0, // 1 for image, 0 for video
      is_admin: user_type === 1 ? 1 : 0, // 1 - admin, 0 - except admin
      page: "", // Empty to fetch all records
      page_size: "", // Empty to fetch all records
      folder_id: id,
    };

    try {
      const res = await AxiosInstance.post("/api/gallery/list", folderPayload);
      const folderItems = res.data?.data?.filter(
        (item) => item.folder_id == id
      );

      // Sort the items based on display_option
      const sortedItems = folderItems.sort(
        (a, b) => b.display_option - a.display_option
      );
      setFolderData(sortedItems);

      // setFolderData(folderItems);
    } catch (error) {
      console.error("Error fetching gallery data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackFilter = () => {
    navigate(`/GalleryVideos`);
  };

  const handleCheckboxChange = (id, foldrId) => {
    setSelectedItemId((prevId) => (prevId === id ? null : id));
    setSelectedFolderId((prevId) => (prevId === foldrId ? null : foldrId));
  };

  const handleDeleteItem = () => {
    if (selectedItemId !== null) {
      setShowConfirmation(true); // Show the confirmation popup
    }
  };
  const handleDeleteFolder = () => {
    if (folderData[0].folder_id !== null) {
      setShowConfirmations(true); // Show the confirmation popup
    }
  };

  const confirmDeleteItem = async () => {
    if (selectedItemId !== null) {
      try {
        let filteredItem = folderData.filter(
          (item) => item.id === selectedItemId
        )[0];
        let payload = {
          id: selectedItemId,
          folder_name: filteredItem.folder_name,
          folder_pk: selectedFolderId,
          display_option: 1,
          img_type: 0, // Assuming the type is always 1 for images/videos
          title: "",
          is_deleted: 1,
          created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid || "",
          files: [
            {
              path: filteredItem.gallery_path,
              originalname: filteredItem.original_gallery_path,
            },
          ],
        };
        console.log("payload", payload);
        await AxiosInstance.post(`/api/gallery/add`, payload)
          .then((res) => {
            // console.log(res);
            if (res.status) {
              toast.success(res.data.message);
              navigate(`/ViewVideos/${id}`);
            } else {
              toast.error(res.data.message);
            }
            setFolderData((prevItems) =>
              prevItems.filter((item) => item.id !== selectedItemId)
            );
            setSelectedItemId(null);
            handleFetchFolderData();
            setShowConfirmation(false);
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.log(error);
      }
    } else {
      console.warn("No item selected for deletion.");
    }
  };
  const confirmDeleteFolder = async () => {
    if (folderData[0].folder_id !== null) {
      try {
        const updateCoures = {
          id: folderData[0].folder_id,
          folder_name: folderData[0].folder_name,
          type: 0,
          is_deleted: 1,
          created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
          created_by: userid,
        };
        await AxiosInstance.post(`/api/gallery/add_folder`, updateCoures)
          .then((res) => {
            // console.log(res);
            if (res.status) {
              toast.success(res.data.message);
              navigate("/GalleryVideos");
            } else {
              toast.error(res.data.message);
            }
            setFolderData((prevItems) =>
              prevItems.filter((item) => item.id !== folderData[0].folder_id)
            );
            setSelectedItemId(null);
            handleFetchFolderData();
            setShowConfirmations(false);
          })
          .catch((error) => {
            return error;
          });
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    } else {
      console.warn("No item selected for deletion.");
    }
  };

  const cancelDeleteItem = () => {
    setShowConfirmation(false); // Close the confirmation popup without deleting
  };
  const cancelDeleteFolder = () => {
    setShowConfirmations(false); // Close the confirmation popup without deleting
  };

  const handleEditItem = () => {
    if (selectedItemId) {
      const selectedFolder = folderData.find(
        (item) => item.id === selectedItemId
      );
      console.log(selectedFolder, "myName");

      if (selectedFolder) {
        navigate(`/EditVideo/${selectedItemId}/${selectedFolderId}`, {
          state: {
            TITLE: selectedFolder.title || "",
            FOLDER_PK: selectedFolder.folder_id || "",
            FOLDER_NAME: selectedFolder.folder_name || "",
            DESCRIPTION: selectedFolder.description || "",
            VIDEO_LINK: selectedFolder.gallery_path || "",
            DISPLAY_OPTION: selectedFolder.display_option || "",
            CREATED_DATE: selectedFolder.created_date || "", // Example: Sending date
          },
        });
      }
    }
  };

  const handleEditFolder = () => {
    navigate(`/EditFolder/${id}/0`);
  };

  // const handleItemClick = (src) => {
  //   setCurrentItem(src);
  //   setShowPopup(true);
  // };

  const handleClosePopup = () => {
    setShowPopup(false);
    setCurrentItem(null);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-4 col-12">
          <h2 className="TitleHeader">View Videos</h2>
        </div>
        <div className="col-md-8 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                onClick={handleBackFilter}
                to="javascript:void(0)"
                className="secondaryButton"
              >
                Back to Videos
              </Link>
            </li>
            {user_type === 1 && (
              <>
                <li className="ListBtnItems">
                  <Button
                    onClick={handleEditFolder}
                    className={`primaryButton text-center border-0 `}
                    variant="primary"
                  >
                    Edit Folder
                  </Button>
                </li>
                <li className="ListBtnItems">
                  <Link
                    className={`primaryButton text-center`}
                    onClick={handleDeleteFolder}
                  >
                    Delete Folder
                  </Link>
                </li>
                <li className="ListBtnItems">
                  <Button
                    onClick={handleEditItem}
                    className={`primaryButton text-center border-0 ${
                      selectedItemId ? "" : `${styles.editDisable}`
                    }`}
                    disabled={!selectedItemId}
                    variant="primary"
                  >
                    Edit Video
                  </Button>
                </li>
                <li className="ListBtnItems">
                  <Link
                    className={`primaryButton text-center ${
                      selectedItemId ? "" : "disabledbtn"
                    }`}
                    disabled={!selectedItemId}
                    onClick={handleDeleteItem}
                  >
                    Delete Video
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div className={`${styles.gridContainer} row pt-2`}>
        {folderData.map((item) => {
          const isYoutubeLink =
            item.gallery_path?.includes("youtube.com") ||
            item.gallery_path?.includes("youtu.be");
          const getYouTubeID = (url) => {
            const regExp =
              /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
            const match = url.match(regExp);
            return match ? match[1] : "";
          };
          const isFacebookLink =
            item.gallery_path && item.gallery_path.includes("facebook.com");
          const isInstagramLink =
            item.gallery_path && item.gallery_path.includes("instagram.com");

          if (item.img_type === null) {
            return (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  fontSize: "16px",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "200px",
                  textAlign: "center",
                }}
              >
                <p>No Videos to Display</p>
              </div>
            );
          }

          return (
            <div key={item.id} className="col-md-6 col-12 mb-4">
              <div className={`${styles.image_card}`}>
                <div
                  className={`${
                    isYoutubeLink || item.gallery_path ? styles.video_card : ""
                  } card`}
                  style={{
                    width: "100%",
                    height: "300px",
                    position: "relative",
                  }}
                >
                  {item.gallery_path ? (
                    isYoutubeLink ? (
                      <iframe
                        src={`https://www.youtube.com/embed/${getYouTubeID(
                          item.gallery_path
                        )}`}
                        title={`Video ${item.id}`}
                        className={`${styles.video} card-img-top`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          filter:
                            item.display_option === 0 ? "blur(3px)" : "none",
                        }}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    ) : isFacebookLink || isInstagramLink ? (
                      <a
                        href={item.gallery_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="card-img-top"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          textDecoration: "none",
                          color: "blue",
                        }}
                      >
                        {isFacebookLink ? (
                          <img src={FB} alt="facebook" id="" />
                        ) : (
                          <></>
                        )}
                        {isInstagramLink ? (
                          <a href="" className="me-3 link-secondary">
                            <img src={INS} alt="insta" id="" />
                          </a>
                        ) : (
                          <></>
                        )}
                      </a>
                    ) : (
                      <a
                        href={item.gallery_path}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                          backgroundColor: "#f0f0f0",
                        }}
                      >
                        <img
                          src={videoIcon}
                          alt="External Video"
                          style={{
                            maxHeight: "80px",
                            width: "auto",
                          }}
                        />
                      </a>
                    )
                  ) : null}

                  {user_type === 1 && (
                    <input
                      type="checkbox"
                      className={styles.checkbox}
                      checked={selectedItemId === item.id}
                      onChange={() =>
                        handleCheckboxChange(item.id, item.folder_id)
                      }
                      style={{
                        position: "absolute",
                        top: "10px",
                        transform: "scale(1.5)",
                        right: "10px",
                      }}
                    />
                  )}
                </div>

                <div className={styles.ImageDescription}>
                  <h5 title={item.title} className={styles.ellipsisTitle}>
                    {item.s_no}. {item.title}
                  </h5>
                  <div
                    title={item.description}
                    className={styles.ellipsisTitle}
                    style={{ fontWeight: "unset" }}
                  >
                    {item.description}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Popup for the item */}
      {showPopup && (
        <div className={styles.modal}>
          <span className={styles.close} onClick={handleClosePopup}>
            &times;
          </span>
          <iframe
            width="100%"
            height="500"
            src={currentItem}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Video"
          />
        </div>
      )}

      {/* Confirmation Popup */}
      {showConfirmation && (
        <ConfirmationPopup
          open={showConfirmation}
          title="Delete Video"
          message="Are you sure you want to delete this video?"
          onConfirm={confirmDeleteItem}
          onCancel={cancelDeleteItem}
        />
      )}
      {showConfirmations && (
        <ConfirmationPopup
          open={showConfirmations}
          title="Delete Folder"
          message="Are you sure you want to delete this folder?"
          onConfirm={confirmDeleteFolder}
          onCancel={cancelDeleteFolder}
        />
      )}
    </div>
  );
}

export default ViewImageAdminInfo;
